import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, change } from 'redux-form';
import {
  changeScreen,
  updateDocumentTimelineConfig
} from '../../redux/actions/user-flow/user-flow-action';
import {
  addSiftScript,
  getDocumentTimeLineObject,
  getCurrentDocScreen,
  setReduxFields
} from '../../utils/library';
import { shouldDisableFields } from '../../utils/document-upload/document-upload';
import {
  APPLICANT_POA,
  APPLICANT_POI,
  FATCA_DECLARATION,
  INDIVIDUAL_POA,
  INDIVIDUAL_POI,
  REPRESENTATIVE_POA,
  REPRESENTATIVE_POI,
  INDIVIDUAL_PERSONAL_IMAGE,
  SCREEN_NAME_DOCUMENT_UPLOAD,
  FORMNAME_RFI,
  INDIVIDUAL,
  EU_REGION,
  DOC_SEQUENCE,
  PAN_CODE
} from '../../utils/constants';
import '../../screens/user-flow/individual/individual-documents-upload/individual-documents-upload.scss';
import './upload-documents.scss';
import find from 'lodash/find';
import uniq from 'lodash/uniq';
import forEach from 'lodash/forEach';
import findLastKey from 'lodash/findLastKey';
import get from 'lodash/get';
import indexOf from 'lodash/indexOf';
import reduce from 'lodash/reduce';
import toLower from 'lodash/toLower';
import UploadDocsSG from '../../screens/user-flow/individual/individual-documents-upload/UploadDocSG';
import { API_URL } from '../../utils/config';
import { required } from '../../utils/validation';
import { MyInfoFloatingButton } from '../../components/myInfoFloatingButton';
import styled from 'styled-components';
import RenderCommonDropdownField from '../RenderCommonDropdownV2';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const DropDown = styled.div`
  height: 40px;
  display: flex;
  flex-direction: column;
`;

const RenderTitle = styled.div`
  height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${COLORS.black};
  display: flex;
  flex-direction: row;
`;

const SubTitle = styled.div`
  height: 18px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.textLightGrey};
`;

class UploadDocsSGComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldscustom: null,
      isEverificationSuccessful: true,
      isShowSamplePhotograph: true,
      selectedScreenIndex: 0,
      clearFile: false
    };
    this.VALID_INDIVIDUAL_DOC_TYPES = [INDIVIDUAL_POI, INDIVIDUAL_POA, FATCA_DECLARATION];
    this.POI_DOCS = [INDIVIDUAL_POI, APPLICANT_POI, REPRESENTATIVE_POI];
    this.POA_DOCS = [INDIVIDUAL_POA, APPLICANT_POA, REPRESENTATIVE_POA];
    this.PERSONAL_IMG_DOCS = [INDIVIDUAL_PERSONAL_IMAGE];
    this.FATCA_DOC = [FATCA_DECLARATION];
    this.reRenderOnUpdate = props.reRenderOnUpdate;
  }

  UNSAFE_componentWillMount = () => {
    addSiftScript();

    const fieldscustom = this.renderFieldsNew(this.props.processesdConfig);
    if (this.props.disableForm) {
      fieldscustom.disableForm = this.props.disableForm;
    }
    this.setState({ fieldscustom });
  };

  componentDidUpdate = (prevProps) => {
    const { reRenderOnUpdate } = this.props;
    const { getAllformVal } = this.props;
    if (
      getAllformVal &&
      getAllformVal.country_code === 'IN' &&
      getAllformVal.currentDocScreen &&
      getAllformVal.currentDocScreen.key === 'POI' &&
      !getAllformVal.call_doc_upload_api
    ) {
      return;
    }
    if (JSON.stringify(reRenderOnUpdate) !== JSON.stringify(prevProps.reRenderOnUpdate)) {
      const fieldscustom = this.renderFieldsNew();
      if (this.props.disableForm) {
        fieldscustom.disableForm = this.props.disableForm;
      }
      this.setState({ fieldscustom });
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.nextScreen && nextProps.nextScreen !== this.props.nextScreen) {
      this.goNext();
    }
  };

  //RENDERFIELDS CUSTOM
  renderFieldsNew = (processesdConfig = this.props.processesdConfig) => {
    const { currentScreen, documentDetails, dispatch, formName, disableDocs, country_code } =
        this.props,
      //loop on sequence
      renderObj = {
        POI: [],
        POA: [],
        PERSONAL_IMAGE: [],
        FATCA: [],
        disableForm: null,
        CORP: []
      };
    if (country_code === 'CA') {
      const isDrivingLicenseUploadedAsPOI = find(documentDetails, {
        document_code: 'DRIVING_LICENSE',
        type: 'INDIVIDUAL_POI'
      });
      if (!isEmpty(isDrivingLicenseUploadedAsPOI)) {
        processesdConfig = this.updateConfig('DRIVING_LICENSE', 'POI');
      }
    }

    if (this.props.renderPOA) {
      const poaDocs = Object.keys(processesdConfig).filter((key) => this.POA_DOCS.includes(key));
      processesdConfig = poaDocs.reduce((acc, key) => {
        acc[key] = processesdConfig[key];
        return acc;
      }, {});
    }

    Object.keys(processesdConfig).forEach((doctype) => {
      if (
        ((this.POI_DOCS.includes(doctype) || this.POA_DOCS.includes(doctype)) &&
          currentScreen === SCREEN_NAME_DOCUMENT_UPLOAD) ||
        formName === FORMNAME_RFI
      ) {
        Object.keys(processesdConfig[doctype]).forEach((seq) => {
          const docTypeString = this.POI_DOCS.includes(doctype) ? 'POI' : 'POA';
          let disableField = false;
          const loopArr = processesdConfig[doctype][seq];

          // if user is all those checks and user is from onfido check is created then he should be not be able move
          // individaul && eu region && document code === PIN

          const { disableForm } =
            this.props.account_type === INDIVIDUAL &&
            EU_REGION.includes(this.props.country_code) &&
            this.props.processesdConfig.INDIVIDUAL_POI.length > 0 &&
            this.props.processesdConfig.INDIVIDUAL_POI[0].document_code ===
              'PERSONAL_IDENTIFICATION_NUMBER'
              ? shouldDisableFields(documentDetails, doctype, dispatch, disableDocs)
              : {
                  disableForm: false,
                  disableFields: false,
                  disableLinks: false
                };
          disableForm
            ? renderObj.disableForm !== false
              ? (renderObj.disableForm = true)
              : (renderObj.disableForm = false)
            : (renderObj.disableForm = false);
          if (loopArr.length >= 2) {
            const detailsSelectedCode = get(
              find(documentDetails, { type: doctype }),
              'document_code',
              null
            );
            if (detailsSelectedCode) {
              dispatch(change(formName, 'document_code', detailsSelectedCode));
            }
            const labelText = docTypeString === 'POI' ? 'Verify identity' : 'Verify address';
            //radio buttons required as multiple docs for same code;
            const dropDownMapping = this.renderDropDown({
              loopArr,
              docTypeString,
              disableForm,
              label: labelText
            });
            const checkedIndex = detailsSelectedCode
              ? reduce(
                  dropDownMapping,
                  (acc, item, index) => {
                    if (item.document_code === detailsSelectedCode) {
                      acc = index;
                    }
                    return acc;
                  },
                  0
                )
              : 0;
            const {
              label,
              document_description,
              links,
              fields,
              document_code,
              linkConfig,
              dropDownToRender,
              parentKey,
              renderDropDown
            } = dropDownMapping[checkedIndex]; //take first element as default
            this.getFileSrc(documentDetails, linkConfig);
            renderObj[docTypeString].push({
              dropDownMapping,
              dropDownToRender,
              label,
              document_description,
              links,
              fields,
              document_code,
              dropDownConfig: loopArr,
              linkConfig,
              document_type: doctype,
              parentKey,
              renderDropDown,
              is_doc_render_visible: false
            });
          } else {
            const { label, document_description, document_code } = loopArr[0];
            let verifyBtn;
            const links = [];
            if (loopArr[0].everification_meta) {
              dispatch(change(formName, 'everification_meta', loopArr[0].everification_meta));
              dispatch(change(formName, 'country_code', country_code));
            }
            if (document_code === PAN_CODE) {
              const panDetails = find(documentDetails, {
                document_code: PAN_CODE
              });
              if (!isEmpty(panDetails) && panDetails.is_everified) {
                disableField = true;
                dispatch(change(formName, 'panEVerified', true));
                dispatch(change(formName, 'name_matched', panDetails.status === 'APPROVED'));
              }
            }
            const linkConfig = loopArr[0];
            this.getFileSrc(documentDetails, linkConfig);
            renderObj[docTypeString].push({
              label,
              document_description,
              links,
              document_code,
              seq,
              linkConfig,
              verifyBtn,
              is_doc_render_visible: false,
              disableField
            });
          }
        });
      } else if (this.PERSONAL_IMG_DOCS.includes(doctype)) {
        // FOR PERSONAL IMG
        Object.keys(processesdConfig[doctype]).forEach((seq) => {
          const docTypeString = 'PERSONAL_IMAGE';
          const loopArr = processesdConfig[doctype][seq];
          // if user is all those checks and user is from onfido check is created then he should be not be able move
          // individaul && eu region && document code === PIN

          const { disableForm } =
            this.props.account_type === INDIVIDUAL &&
            EU_REGION.includes(this.props.country_code) &&
            this.props.processesdConfig.INDIVIDUAL_POI.length > 0 &&
            this.props.processesdConfig.INDIVIDUAL_POI[0].document_code ===
              'PERSONAL_IDENTIFICATION_NUMBER'
              ? shouldDisableFields(documentDetails, doctype, dispatch, disableDocs)
              : {
                  disableForm: false,
                  disableFields: false,
                  disableLinks: false
                };
          disableForm
            ? renderObj.disableForm !== false
              ? (renderObj.disableForm = true)
              : (renderObj.disableForm = false)
            : (renderObj.disableForm = false);
          if (loopArr.length >= 2) {
            const detailsSelectedCode = get(
              find(documentDetails, { type: doctype }),
              'document_code',
              null
            );
            if (detailsSelectedCode) {
              dispatch(change(formName, 'document_code', detailsSelectedCode));
            }
            //radio buttons required as multiple docs for same code;
            const dropDownMapping = this.renderDropDown({
              loopArr,
              docTypeString,
              disableForm
            });
            const checkedIndex = detailsSelectedCode
              ? reduce(
                  dropDownMapping,
                  (acc, item, index) => {
                    if (item.document_code === detailsSelectedCode) {
                      acc = index;
                    }
                    return acc;
                  },
                  0
                )
              : 0;
            const {
              label,
              document_description,
              links,
              fields,
              document_code,
              linkConfig,
              dropDownToRender,
              parentKey,
              renderDropDown
            } = dropDownMapping[checkedIndex]; //take first element as default
            this.getFileSrc(documentDetails, linkConfig);
            renderObj[docTypeString].push({
              dropDownMapping,
              dropDownToRender,
              label,
              document_description,
              links,
              fields,
              document_code,
              dropDownConfig: loopArr,
              linkConfig,
              document_type: doctype,
              parentKey,
              renderDropDown,
              is_doc_render_visible: false
            });
          } else {
            const { label, document_description, document_code } = loopArr[0],
              links = [];
            let verifyBtn;
            if (loopArr[0].everification_meta) {
              dispatch(change(formName, 'everification_meta', loopArr[0].everification_meta));
              dispatch(change(formName, 'country_code', country_code));
            }
            const linkConfig = loopArr[0];
            this.getFileSrc(documentDetails, linkConfig);
            renderObj[docTypeString].push({
              label,
              document_description,
              links,
              document_code,
              seq,
              linkConfig,
              verifyBtn,
              is_doc_render_visible: false
            });
          }
        });
      }
    });
    const submittedDocs = compact(
      uniq(
        documentDetails.map((item) => {
          if (item.is_document_uploaded) {
            return item.type;
          }
          return false;
        })
      )
    );
    Object.keys(renderObj).forEach((item) => {
      if (renderObj[item] && Array.isArray(renderObj[item]) && renderObj[item].length === 0) {
        delete renderObj[item];
      }
    });
    let isAllSubmitted = true;
    let selectedScreenIndex = 0;
    const ACTUAL_DOC_SEQUENCE = [];
    forEach(DOC_SEQUENCE, (item) => {
      if (renderObj[item]) {
        ACTUAL_DOC_SEQUENCE.push(item);
      }
    });
    this.setState({
      ACTUAL_DOC_SEQUENCE: ACTUAL_DOC_SEQUENCE
    });
    forEach(ACTUAL_DOC_SEQUENCE, (item) => {
      if (
        !find(submittedDocs, (child) => {
          return child.includes(item);
        })
      ) {
        if (renderObj[item]) {
          const updatedItem = renderObj[item].map((data) => {
            return { ...data, is_doc_render_visible: true };
          });
          renderObj[item] = updatedItem;
          isAllSubmitted = false;
          selectedScreenIndex = indexOf(ACTUAL_DOC_SEQUENCE, item);
          return false;
        }
      }
    });
    const lastKey = findLastKey(renderObj);
    dispatch(change(formName, 'last_doc_screen', lastKey));
    if (isAllSubmitted) {
      const updatedItem = renderObj[lastKey].map((data) => {
        return { ...data, is_doc_render_visible: true };
      });
      renderObj[lastKey] = updatedItem;
      selectedScreenIndex = indexOf(ACTUAL_DOC_SEQUENCE, lastKey);
    }
    this.props.updateDocumentTimelineConfig({
      selectedDocIndex: selectedScreenIndex,
      backFunction: this.goBack
    });
    this.setState({
      selectedScreenIndex: selectedScreenIndex
    });
    return { ...renderObj };
  };

  goBack = (currentDocScreen) => {
    const {
      getAllformVal: { currentDocScreen: propsCurrentDocScreen }
    } = this.props;
    if (!currentDocScreen) {
      currentDocScreen = propsCurrentDocScreen;
    }
    const ACTUAL_DOC_SEQUENCE = this.state.ACTUAL_DOC_SEQUENCE;
    const currentScreenIndex = indexOf(ACTUAL_DOC_SEQUENCE, currentDocScreen.key);
    const prevIndex = currentScreenIndex - 1;
    const prevScreen = ACTUAL_DOC_SEQUENCE[prevIndex];
    const renderObject = this.state.fieldscustom;
    const prevElement = renderObject[prevScreen];
    const updatedRenderObject = {};
    Object.keys(renderObject).forEach((key) => {
      if (renderObject[key] && Array.isArray(renderObject[key])) {
        const newElement = renderObject[key].map((item) => {
          return { ...item, is_doc_render_visible: false };
        });
        updatedRenderObject[key] = newElement;
      } else {
        updatedRenderObject[key] = renderObject[key];
      }
    });
    const newElement = prevElement.map((item) => {
      return { ...item, is_doc_render_visible: true };
    });
    updatedRenderObject[prevScreen] = newElement;
    this.props.updateDocumentTimelineConfig({
      selectedDocIndex: prevIndex,
      backFunction: this.goBack
    });
    this.setState({
      fieldscustom: updatedRenderObject,
      selectedScreenIndex: prevIndex
    });
  };

  goNext = () => {
    const currentScreenIndex = this.state.selectedScreenIndex;
    const nextIndex = currentScreenIndex + 1;
    const ACTUAL_DOC_SEQUENCE = this.state.ACTUAL_DOC_SEQUENCE;
    const nextScreen = ACTUAL_DOC_SEQUENCE[nextIndex];
    const renderObject = this.state.fieldscustom;
    const nextElement = renderObject[nextScreen];
    const updatedRenderObject = {};
    Object.keys(renderObject).forEach((key) => {
      if (renderObject[key] && Array.isArray(renderObject[key])) {
        const newElement = renderObject[key].map((item) => {
          return { ...item, is_doc_render_visible: false };
        });
        updatedRenderObject[key] = newElement;
      } else {
        updatedRenderObject[key] = renderObject[key];
      }
    });
    const newElement = nextElement.map((item) => {
      return { ...item, is_doc_render_visible: true };
    });
    updatedRenderObject[nextScreen] = newElement;
    this.props.updateDocumentTimelineConfig({
      selectedDocIndex: nextIndex,
      backFunction: this.goBack
    });
    this.setState({
      fieldscustom: updatedRenderObject,
      selectedScreenIndex: nextIndex
    });
  };

  renderDropDownOptions = (options) => {
    if (!options) options = [];
    return options.map((item) => {
      const { text, key, value } = item;
      return {
        key,
        value,
        text: text,
        content: (
          <DropDown id={value}>
            <RenderTitle id={`title-${value}`}>{text}</RenderTitle>
            <SubTitle id={`sub-title-${value}`}>{`Upload ${toLower(text)}`}</SubTitle>
          </DropDown>
        )
      };
    });
  };

  renderDropDown = ({ loopArr, docTypeString, disableForm, label }) => {
    const { getAllformVal } = this.props;
    const generateDropDown = (staticValues, url) => (
      <div>
        <div className="label-new-upload-doc">{label}</div>
        <div className="new-doc-dropdown">
          <Field
            bindToThisObject={getAllformVal && getAllformVal['document_code']}
            type="text"
            name={'document_code'}
            component={RenderCommonDropdownField}
            placeholder={`Select any one document`}
            className={`theme-dropdown`}
            validate={[required]}
            url={url ? `${API_URL}/${url}` : null}
            options={this.renderDropDownOptions(staticValues)}
            staticValues={this.renderDropDownOptions(staticValues)}
            preselect_if_one_item={true}
            disabled={disableForm}
            enableThis={getAllformVal && getAllformVal['document_code'] ? false : true}
            onDropdownChange={() =>
              this.clearValuesFor({
                docType: docTypeString
              })
            }
          />
        </div>
      </div>
    );
    const staticValues = loopArr.map((item) => {
      return {
        key: item.label,
        value: item.document_code,
        text: item.label
      };
    });
    const dropDownMapping = loopArr.map((ele) => {
      const dropDownToRender = generateDropDown(staticValues);
      const { label, document_description, document_code, checked, type } = ele;
      return {
        dropDownToRender,
        label,
        document_description,
        document_code,
        checked,
        type,
        linkConfig: ele,
        parentKey: 'document_code',
        renderDropDown: true
      };
    });
    return dropDownMapping;
  };

  removeDL_POA = (processesdConfig, type) => {
    const newPOA =
      type === 'POI' &&
      processesdConfig.INDIVIDUAL_POA[1].filter((item) => item.document_code !== 'DRIVING_LICENSE');
    if (type === 'POI') {
      return {
        ...processesdConfig,
        INDIVIDUAL_POA: { 1: newPOA }
      };
    } else {
      return null;
    }
  };

  setProccessConfigCheck = (type, radioValue) => {
    if (type === 'POI') {
      if (radioValue === 'DRIVING_LICENSE') {
        if (this.removeDL_POA(this.props.processesdConfig, type)) {
          return this.removeDL_POA(this.props.processesdConfig, type);
        }
      }
    }
  };

  updateConfig(radioValue, type) {
    return this.setProccessConfigCheck(type, radioValue);
  }

  //clear values on radio change
  clearValuesFor = ({ docType }) => {
    const {
      getAllformVal,
      getAllformVal: { document_code }
    } = this.props;
    if (!document_code || !docType) {
      return;
    }
    const type = `INDIVIDUAL_${docType}`;
    if (!getAllformVal || !getAllformVal[type] || !getAllformVal[type][document_code]) return;
    const currentFieldState = { ...this.state.fieldscustom };
    const setObj = {};
    setObj[type] = getAllformVal[type] ? { ...getAllformVal[type] } : {};

    if (setObj && getAllformVal[type]) {
      // reset
      delete setObj[type][document_code];
      setReduxFields(this.props.dispatch, change, this.props.formName, setObj);
    }

    currentFieldState[docType][0].linkConfig['fileSrc'] = null;
    currentFieldState[docType][0].linkConfig['fileSrcBack'] = null;
    const clearFile = this.state.clearFile;
    this.setState({
      fieldscustom: currentFieldState,
      clearFile: !clearFile
    });
  };

  getFileSrc = (documentDetails, ele) => {
    const existingDocs = documentDetails.filter(
      (key) => key.document_code === ele.document_code && key.type === ele.type && !ele.fileSrc
    );
    if (existingDocs) {
      //file initialization
      existingDocs.forEach((doc) => {
        if (doc.document_detail_id && doc.is_document_uploaded) {
          ele[doc.is_back_document ? 'fileSrcBack' : 'fileSrc'] =
            API_URL + '/static/document/' + doc.document_detail_id;
          ele[doc.is_back_document ? 'actual_file_name_back' : 'actual_file_name'] =
            doc.actual_file_name;
        }
      });
    }
  };

  render() {
    const {
      currentScreen,
      country_code,
      skipScreen,
      isEmbeddedSection,
      removePadding,
      sectionHead,
      getAllformVal,
      hideUploadDocScreen
    } = this.props;
    const { fieldscustom, isEverificationSuccessful } = this.state;
    const noPadClass = `${removePadding ? 'no-padding' : ''}`;
    const timeLine = Object.keys(this.props.processesdConfig);
    const timelineSorted = this.props.renderPOA
      ? timeLine.filter((item) => item !== INDIVIDUAL_PERSONAL_IMAGE)
      : timeLine;
    return (
      <>
        <UploadDocsSG
          processesdConfig={this.props.processesdConfig}
          currentScreen={currentScreen}
          formName={this.props.formName}
          country_code={country_code}
          isEmbeddedSection={isEmbeddedSection}
          sectionHead={sectionHead}
          skipScreen={skipScreen}
          fieldscustom={fieldscustom}
          isEverificationSuccessful={isEverificationSuccessful}
          noPadClass={noPadClass}
          isShowSamplePhotograph={this.state.isShowSamplePhotograph}
          noButtonNeeded={this.props.noButtonNeeded}
          timeLine={getDocumentTimeLineObject(timelineSorted)}
          currentDocScreen={getCurrentDocScreen(fieldscustom)}
          getAllformVal={getAllformVal}
          goBack={this.goBack}
          selectedScreenIndex={this.state.selectedScreenIndex}
          clearFile={this.state.clearFile}
          validate={this.props.validate}
          hideUploadDocScreen={hideUploadDocScreen}
          renderPOA={this.props.renderPOA}
        />
        {country_code === 'SG' && <MyInfoFloatingButton pageName="Doc Upload" />}
      </>
    );
  }
}

UploadDocsSGComponent.propTypes = {
  processesdConfig: PropTypes.any,
  currentScreen: PropTypes.string,
  documentDetails: PropTypes.array,
  dispatch: PropTypes.func,
  getAllformVal: PropTypes.any,
  country_code: PropTypes.string,
  account_type: PropTypes.string,
  skipScreen: PropTypes.func,
  formName: PropTypes.string,
  validate: PropTypes.array,
  linkEle: PropTypes.object,
  reRenderOnUpdate: PropTypes.bool,
  disableDocs: PropTypes.bool,
  isEmbeddedSection: PropTypes.bool,
  sectionHead: PropTypes.string,
  sectionSubHead: PropTypes.string,
  screenConfig: PropTypes.object,
  removePadding: PropTypes.any,
  disableForm: PropTypes.bool,
  noButtonNeeded: PropTypes.bool,
  updateDocumentTimelineConfig: PropTypes.func,
  nextScreen: PropTypes.any,
  hideUploadDocScreen: PropTypes.any,
  renderPOA: PropTypes.bool
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      changeScreen,
      updateDocumentTimelineConfig,
      dispatch
    },
    dispatch
  )
)(UploadDocsSGComponent);
